var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "simple__block" },
      [
        _c(
          "div",
          { staticClass: "order__block_info" },
          [
            ["sent"].includes(_vm.ordertype)
              ? [
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.formatText(
                            _vm.get_translation_constant(
                              "text_tracking_number_full"
                            )
                          )
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "order__traking_number",
                        attrs: { href: "javascript:void(0)" },
                      },
                      [_vm._v(_vm._s(_vm.parcel.track_code))]
                    ),
                    _c("span", { staticClass: "copy__traking_number" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z",
                              fill: "#06C",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "copy__traking_alert" }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_copied_to_clipboard"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.formatText(
                            _vm.get_translation_constant("text_arrival_date")
                          )
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.getParcelDate))]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.formatText(
                            _vm.get_translation_constant("text_flight")
                          )
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.getOrderFlight(_vm.parcel))),
                  ]),
                ]
              : ["delivered"].includes(_vm.ordertype) &&
                _vm.parcel.location_id === 1
              ? [
                  _c("div", { staticClass: "order__block_info" }, [
                    _c("p", [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.formatText(
                              _vm.get_translation_constant(
                                "text_tracking_number_full"
                              )
                            )
                          ) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "order__traking_number",
                          attrs: { href: "javascript:void(0)" },
                        },
                        [_vm._v(_vm._s(_vm.parcel.track_code))]
                      ),
                      _c("span", { staticClass: "copy__traking_number" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z",
                                fill: "#06C",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "copy__traking_alert" }, [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_copied_to_clipboard"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.formatText(_vm.getDateText)) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getParcelDate))]),
                    ]),
                    _vm._v(" "),
                    typeof _vm.parcel.market_link !== "undefined"
                      ? _c("p", [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.formatText(
                                  _vm.get_translation_constant("text_shop")
                                )
                              ) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "order__shop_link",
                              attrs: { href: _vm.parcel.market_link },
                            },
                            [_vm._v(_vm._s(_vm.parcel.market.title))]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "order__print" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z",
                              fill: "#515154",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  typeof _vm.parcel.products !== "undefined" &&
                  _vm.parcel.products.length
                    ? _c("div", { staticClass: "order__block_list" }, [
                        _c("h3", { staticClass: "h_text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant("text_product_list")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "table",
                          { staticClass: "table table__order_item" },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_nomenclature"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_additional_services"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_quantity"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant("text_price")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant("text_total")
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.parcel.products,
                                function (product, key) {
                                  return _c("tr", [
                                    _c("td", [
                                      _c("a", { attrs: { href: "#" } }, [
                                        _vm._v(_vm._s(product.name)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center",
                                        },
                                        _vm._l(
                                          _vm.parcel.services,
                                          function (service, service_index) {
                                            return _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "tooltip__block tooltip__top tooltip__block_simple",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tooltip__block_trigger",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "service-image",
                                                      attrs: {
                                                        src: service.icon,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tooltip__block_inner",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(service.title)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(_vm._s(product.qty) + " х"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(_vm._s(product.price) + " $"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              product.price * product.qty
                                            ).toFixed(2)
                                          ) + " $"
                                        ),
                                      ]),
                                    ]),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-4" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 text-md-end" },
                            [
                              _c(
                                "div",
                                { staticClass: "packages__total_price" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_total_products_price"
                                        )
                                      ) +
                                      ":\n                                    "
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.totalProductPrice)),
                                  ]),
                                  _vm._v(
                                    " $\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("p", [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_tracking_number_full"
                              )
                            ) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "order__traking_number",
                            attrs: { href: "#" },
                          },
                          [_vm._v(_vm._s(_vm.parcel.track_code))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "copy__traking_number" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z",
                                  fill: "#06C",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "copy__traking_alert" }, [
                            _vm._v(
                              _vm._s(
                                _vm.get_translation_constant(
                                  "text_copied_to_clipboard"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant("text_flight")
                            ) + ":"
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.getOrderFlight(_vm.parcel)) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto pl-md-5" }, [
                      _c("p", [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant("text_arrival_date")
                            ) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.parcel.date))]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant("text_bar_code")
                            ) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v(
                            _vm._s(
                              typeof _vm.parcel.bar_code !== "undefined" &&
                                typeof _vm.parcel.bar_code !== null
                                ? _vm.parcel.bar_code
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
            _vm._v(" "),
            _c("div", { staticClass: "order__print" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z",
                      fill: "#515154",
                    },
                  }),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        ["sent"].includes(_vm.ordertype)
          ? _c("h4", { staticClass: "h_text" }, [
              _vm._v(_vm._s(_vm.get_translation_constant("text_bill"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        !["delivered"].includes(_vm.ordertype) && _vm.parcel.location_id === 1
          ? _c("table", { staticClass: "table table__arrived__item__orders" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_weight"))),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_rate"))),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant("text_additional_services")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.parcelNotPaidBill &&
                  _vm.parcel.parcel_tracking_status_id > 4
                    ? _c("th", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.get_translation_constant("text_customs_tax")
                            ) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_total"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c(
                  "tr",
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          "data-label":
                            _vm.get_translation_constant("text_weight"),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.parcel.weight) +
                            _vm._s(_vm.get_translation_constant("text_kg")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.parcel.location_id === 1 &&
                    ["arrived"].includes(_vm.ordertype)
                      ? [
                          _c(
                            "td",
                            {
                              attrs: {
                                "data-label":
                                  _vm.get_translation_constant("text_rate"),
                              },
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.parcel.tariff_to_kg)),
                              ]),
                            ]
                          ),
                        ]
                      : [
                          _vm.parcel.tariff !== null
                            ? _c(
                                "td",
                                {
                                  attrs: {
                                    "data-label":
                                      _vm.get_translation_constant("text_rate"),
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.parcel.tariff) + "$"),
                                  ]),
                                ]
                              )
                            : _c(
                                "td",
                                {
                                  attrs: {
                                    "data-label":
                                      _vm.get_translation_constant("text_rate"),
                                  },
                                },
                                [_vm._v("-")]
                              ),
                        ],
                    _vm._v(" "),
                    (_vm.parcel.services !== null &&
                      _vm.parcel.services.length > 0) ||
                    (_vm.parcel.solutions !== null &&
                      _vm.parcel.solutions.length > 0)
                      ? _c(
                          "td",
                          {
                            attrs: {
                              "data-label": _vm.get_translation_constant(
                                "text_additional_services"
                              ),
                            },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.totalServicesSum)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "tooltip__block tooltip__bottom tooltip__modal",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_trigger" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                            fill: "#515154",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_overlay" },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "tooltip__block_inner tooltip__small",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getServicesPrices
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _c(
                          "td",
                          {
                            attrs: {
                              "data-label": _vm.get_translation_constant(
                                "text_additional_services"
                              ),
                            },
                          },
                          [_vm._v("-")]
                        ),
                    _vm._v(" "),
                    _vm.parcelNotPaidBill &&
                    _vm.parcel.parcel_tracking_status_id > 4
                      ? _c("td", [
                          _c(
                            "strong",
                            { class: [_vm.billStatusClass, "customs-error"] },
                            [_vm._v(_vm._s(_vm.parcel.bill.amount) + "$")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "tooltip__block tooltip__bottom tooltip__modal",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "tooltip__block_trigger" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                          fill: "#515154",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "tooltip__block_overlay" },
                                [
                                  _c("span", {
                                    staticClass:
                                      "tooltip__block_inner tooltip__small",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.parcelDocumentRequestData.content
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.parcel.total_price !== null
                      ? _c(
                          "td",
                          {
                            attrs: {
                              "data-label":
                                _vm.get_translation_constant("text_total"),
                            },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.parcel.total_price) + "$"),
                            ]),
                          ]
                        )
                      : _c(
                          "td",
                          {
                            attrs: {
                              "data-label":
                                _vm.get_translation_constant("text_total"),
                            },
                          },
                          [_vm._v("-")]
                        ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        ["sent", "arrived"].includes(_vm.ordertype)
          ? [
              _c(
                "div",
                {
                  staticClass: "d-flex align-items-center agent__info",
                  style:
                    !_vm.orderPaid && ["sent"].includes(_vm.ordertype)
                      ? ""
                      : "display: none !important;",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.get_translation_constant(
                          "text_delivery_through_agent"
                        )
                      ) +
                      "\n                    "
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "tooltip__block tooltip__bottom tooltip__modal",
                    },
                    [
                      _c("span", { staticClass: "tooltip__block_trigger" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 14 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                fill: "#515154",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "tooltip__block_overlay" }, [
                        _c("span", { staticClass: "tooltip__block_inner" }, [
                          _c("span", { staticClass: "tooltip__block_close" }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.get_translation_constant(
                                  "text_creating_agents_is_relevant"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { attrs: { href: "#" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "text_learn_more_about_agents"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    !_vm.orderPaid && ["sent"].includes(_vm.ordertype)
                      ? "d-md-flex justify-content-between align-items-center"
                      : "d-md-flex justify-content-end align-items-center",
                  style: !_vm.orderPaid ? "" : "display: none !important;",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text__small color__red mb-3 mb-md-0",
                      style:
                        !_vm.orderPaid && ["sent"].includes(_vm.ordertype)
                          ? ""
                          : "display: none !important;",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.get_translation_constant("text_pay_for_order")
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn__large btn__blue d-block",
                      attrs: {
                        href: "#",
                        "data-bs-toggle": "modal",
                        id: "orderPaymentTrigger",
                        "data-bs-target": "#orderPayment",
                      },
                    },
                    [_vm._v(_vm._s(_vm.get_translation_constant("text_pay")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-md-flex justify-content-еnd mt-4",
                  style:
                    !!_vm.orderPaid &&
                    (_vm.order.shipping_info === null ||
                      (_vm.order.shipping_method !== null &&
                        _vm.order.shipping_method.pre_save))
                      ? ""
                      : "display: none !important;",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center agent__info",
                      style: ["sent"].includes(_vm.ordertype)
                        ? ""
                        : "display: none !important;",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_delivery_through_agent"
                            )
                          ) +
                          "\n                        "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "tooltip__block tooltip__bottom tooltip__modal",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "tooltip__block_trigger" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 14 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip__block_overlay" },
                            [
                              _c(
                                "span",
                                { staticClass: "tooltip__block_inner" },
                                [
                                  _c("span", {
                                    staticClass: "tooltip__block_close",
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_creating_agents_is_relevant"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("a", { attrs: { href: "#" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_learn_more_about_agents"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn__large btn__green d-block",
                      attrs: {
                        href: "#",
                        "data-bs-toggle": "modal",
                        id: "orderDeliveryTrigger",
                        "data-bs-target": "#orderDelivery",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_arrange_delivery")
                        )
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade modal__custom",
                  attrs: {
                    id: "orderPayment",
                    tabindex: "-1",
                    role: "dialog",
                    "aria-labelledby": "orderPaymentTitle",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      attrs: { role: "document" },
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "orderPaymentTitle" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "text_order_payment"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal",
                              "aria-label": "Close",
                              id: "orderPaymentClose",
                              "data-bs-target": "#orderPayment",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "table",
                            { staticClass: "table table__order_payment" },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _c("p", [
                                      _c("span", { staticClass: "h_text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.get_translation_constant(
                                              "text_bill"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(_vm.form.orders.length) +
                                          "\n                                                (" +
                                          _vm._s(
                                            _vm.get_translation_constant(
                                              "text_one_order"
                                            )
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("th"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.form.orders,
                                  function (form_order, key) {
                                    return _c("tr", [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.get_translation_constant(
                                              "text_order_number"
                                            )
                                          ) + _vm._s(form_order.id)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getTotalPrice(form_order)
                                          ) + " $"
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _c("tfoot", [
                                _c("tr", [
                                  _c("td", { staticClass: "h6 color__black" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_total"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.calculatedOrdersTotalSum)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("form", { attrs: { action: "" } }, [
                            _c(
                              "div",
                              { staticClass: "row align-items-baseline" },
                              [
                                _c("div", { staticClass: "col-12 col-md-8" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form__col",
                                      class: _vm.hasError("paymentMethod"),
                                    },
                                    [
                                      _c(
                                        "multiselect",
                                        {
                                          staticClass: "form-control",
                                          attrs: {
                                            multiple: false,
                                            placeholder:
                                              _vm.get_translation_constant(
                                                "text_choose_method"
                                              ),
                                            options: _vm.filteredPaymentMethods,
                                            label: "title",
                                            selectLabel: "",
                                            deselectLabel: "",
                                            optionHeight: 48,
                                            showPointer: true,
                                          },
                                          model: {
                                            value: _vm.form.paymentMethod,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "paymentMethod",
                                                $$v
                                              )
                                            },
                                            expression: "form.paymentMethod",
                                          },
                                        },
                                        [void 0],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.hasErrorMessage("paymentMethod")
                                        ? _c(
                                            "div",
                                            { staticClass: "form__error" },
                                            [
                                              _vm.form.paymentMethod === null
                                                ? [
                                                    _vm._v(
                                                      "\n                                                        " +
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_insufficient_funds"
                                                          )
                                                        ) +
                                                        "\n                                                    "
                                                    ),
                                                  ]
                                                : _vm.checkFunds
                                                ? [
                                                    _vm._v(
                                                      "\n                                                        " +
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_insufficient_funds"
                                                          )
                                                        ) +
                                                        "\n                                                    "
                                                    ),
                                                  ]
                                                : [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.get_translation_constant(
                                                            "text_field_is_required"
                                                          )
                                                        ) +
                                                        "\n                                                    "
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c("div", { staticClass: "form__col" }, [
                                    _c("input", {
                                      staticClass:
                                        "btn btn__large btn__blue btn__block payment__success",
                                      attrs: { type: "submit" },
                                      domProps: {
                                        value:
                                          _vm.get_translation_constant(
                                            "text_pay"
                                          ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.pay()
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade modal__custom",
                  attrs: {
                    id: "orderDelivery",
                    tabindex: "-1",
                    role: "dialog",
                    "aria-labelledby": "orderDeliveryTitle",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      attrs: { role: "document" },
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "orderDeliveryTitle" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_arrange_delivery"
                                    )
                                  )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal",
                              "aria-label": "Close",
                              id: "orderDeliveryClose",
                              "data-bs-target": "#orderDelivery",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "form",
                            { attrs: { action: "" } },
                            [
                              _c("h5", { staticClass: "h_text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_choose_delivery_method"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form__col d-none d-md-block" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row no-gutters radio_group__custom",
                                    },
                                    _vm._l(
                                      _vm.deliverymethods,
                                      function (method, key) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-md-4 radio_group__item",
                                            class: _vm.getClassDeliveryUkraine,
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                id: method.title,
                                                type: "radio",
                                              },
                                              domProps: {
                                                checked:
                                                  method.id ===
                                                  _vm.form.deliveryMethod.id,
                                                value: method.id,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setDelivery(method)
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              { attrs: { for: method.title } },
                                              [_vm._v(_vm._s(method.title))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form__col d-md-none delivery__select",
                                },
                                [
                                  _c("multiselect", {
                                    staticClass: "form-control",
                                    attrs: {
                                      multiple: false,
                                      placeholder: _vm.get_translation_constant(
                                        "text_choose_delivery_method"
                                      ),
                                      options: _vm.deliveryMethodsWithDefault,
                                      label: "title",
                                      selectLabel: "",
                                      deselectLabel: "",
                                      optionHeight: 48,
                                      showPointer: true,
                                    },
                                    model: {
                                      value: _vm.form.deliveryMethod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "deliveryMethod",
                                          $$v
                                        )
                                      },
                                      expression: "form.deliveryMethod",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.deliverymethods,
                                function (method, key) {
                                  return [
                                    _vm.account.location_id === 1
                                      ? [
                                          method.shipping_type_id === 1
                                            ? void 0
                                            : method.shipping_type_id === 2
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .id !==
                                                            "undefined" &&
                                                          method.id ===
                                                            _vm.form
                                                              .deliveryMethod
                                                              .id,
                                                        expression:
                                                          "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "delivery__address_block",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.city",
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_city"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_choose_city"
                                                                        ),
                                                                      options:
                                                                        method.cities,
                                                                      label:
                                                                        "title",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .city,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod,
                                                                            "city",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.city",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.city",
                                                                  true
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.address"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_delivery_address"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .address,
                                                                      expression:
                                                                        "form.deliveryMethod.address",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    id: "address",
                                                                    name: "address",
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_enter_address_latin_letters"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .address,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "address",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.address"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "agent"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_choose_agent"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_choose_agent"
                                                                        ),
                                                                      options:
                                                                        _vm.agentList,
                                                                      label:
                                                                        "name",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "singleLabel",
                                                                            fn: function (
                                                                              ref
                                                                            ) {
                                                                              var option =
                                                                                ref.option
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "multiselect__single",
                                                                                    class:
                                                                                      typeof option.id !==
                                                                                        "undefined" &&
                                                                                      option.id ===
                                                                                        ""
                                                                                        ? "multiselect__placeholder__active"
                                                                                        : "",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        typeof option.id !==
                                                                                          "undefined" &&
                                                                                          option.id ===
                                                                                            ""
                                                                                          ? _vm.get_translation_constant(
                                                                                              "text_delivery_through_agent"
                                                                                            )
                                                                                          : option.name
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .agent,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod,
                                                                            "agent",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.agent",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "agent"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "phone_prefix"
                                                                  ) ||
                                                                  _vm.hasError(
                                                                    "phone_number"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_phone"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "phone__block",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "multiselect",
                                                                      {
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          multiple: false,
                                                                          placeholder:
                                                                            "",
                                                                          options:
                                                                            _vm.locationPrefixes,
                                                                          label:
                                                                            "title",
                                                                          selectLabel:
                                                                            "",
                                                                          deselectLabel:
                                                                            "",
                                                                          optionHeight: 48,
                                                                          showPointer: true,
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "singleLabel",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                              {
                                                                                key: "option",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .form
                                                                              .phone_prefix,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_prefix",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "form.phone_prefix",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .phone_number,
                                                                              expression:
                                                                                "form.phone_number",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "form__control type_tel",
                                                                        attrs: {
                                                                          type: "tel",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .phone_number,
                                                                          },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_number",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm.hasErrorMessage(
                                                                      "phone_prefix"
                                                                    ) ||
                                                                    _vm.hasError(
                                                                      "phone_number"
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form__error",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  _vm.get_translation_constant(
                                                                                    "text_field_is_required"
                                                                                  )
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : method.shipping_type_id === 3
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .id !==
                                                            "undefined" &&
                                                          method.id ===
                                                            _vm.form
                                                              .deliveryMethod
                                                              .id,
                                                        expression:
                                                          "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "delivery__address_block",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.first_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_first_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .first_name,
                                                                      expression:
                                                                        "form.deliveryMethod.first_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressFirstName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_first_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .first_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "first_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.first_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.last_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_last_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .last_name,
                                                                      expression:
                                                                        "form.deliveryMethod.last_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressLastName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_last_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .last_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "last_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.last_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.middle_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_middle_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .middle_name,
                                                                      expression:
                                                                        "form.deliveryMethod.middle_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressMiddleName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_middle_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .middle_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "middle_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.middle_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.text_your_city"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_city"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_enter_street_in_ukraine_letters"
                                                                        ),
                                                                      options:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .cities,
                                                                      label:
                                                                        "Description",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    on: {
                                                                      "search-change":
                                                                        _vm.asyncCities,
                                                                      select:
                                                                        _vm.loadStreetsOrWarehouses,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .city,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod
                                                                              .novaPoshta,
                                                                            "city",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.city",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.street"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.novaPoshta.street"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_delivery_street"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_enter_street_in_ukraine_letters"
                                                                        ),
                                                                      options:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .streets,
                                                                      label:
                                                                        "Description",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    on: {
                                                                      "search-change":
                                                                        _vm.searchTimeOut,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .street,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod
                                                                              .novaPoshta,
                                                                            "street",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.street",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.street"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.novaPoshta.house"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_choose_house"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .house,
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.house",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_house"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .novaPoshta
                                                                        .house,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod
                                                                            .novaPoshta,
                                                                          "house",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.house"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.novaPoshta.flat"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_choose_house"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .flat,
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.flat",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_flat"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .novaPoshta
                                                                        .flat,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod
                                                                            .novaPoshta,
                                                                          "flat",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.flat"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "agent"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_recipient"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_choose_agent"
                                                                        ),
                                                                      options:
                                                                        _vm.agentList,
                                                                      label:
                                                                        "name",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    on: {
                                                                      select:
                                                                        _vm.updateNames,
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "singleLabel",
                                                                            fn: function (
                                                                              ref
                                                                            ) {
                                                                              var option =
                                                                                ref.option
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "multiselect__single",
                                                                                    class:
                                                                                      typeof option.id !==
                                                                                        "undefined" &&
                                                                                      option.id ===
                                                                                        ""
                                                                                        ? "multiselect__placeholder__active"
                                                                                        : "",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        typeof option.id !==
                                                                                          "undefined" &&
                                                                                          option.id ===
                                                                                            ""
                                                                                          ? _vm.get_translation_constant(
                                                                                              "text_delivery_through_agent"
                                                                                            )
                                                                                          : option.name
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .agent,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod,
                                                                            "agent",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.agent",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "agent"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "phone_prefix"
                                                                  ) ||
                                                                  _vm.hasError(
                                                                    "phone_number"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_phone"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "phone__block",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "multiselect",
                                                                      {
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          multiple: false,
                                                                          placeholder:
                                                                            "",
                                                                          options:
                                                                            _vm.locationPrefixes,
                                                                          label:
                                                                            "title",
                                                                          selectLabel:
                                                                            "",
                                                                          deselectLabel:
                                                                            "",
                                                                          optionHeight: 48,
                                                                          showPointer: true,
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "singleLabel",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                              {
                                                                                key: "option",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .form
                                                                              .phone_prefix,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_prefix",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "form.phone_prefix",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .phone_number,
                                                                              expression:
                                                                                "form.phone_number",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "form__control type_tel",
                                                                        attrs: {
                                                                          type: "tel",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .phone_number,
                                                                          },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_number",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm.hasErrorMessage(
                                                                      "phone_prefix"
                                                                    ) ||
                                                                    _vm.hasError(
                                                                      "phone_number"
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form__error",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  _vm.get_translation_constant(
                                                                                    "text_field_is_required"
                                                                                  )
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : method.shipping_type_id === 4
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.form
                                                            .deliveryMethod
                                                            .id !==
                                                            "undefined" &&
                                                          method.id ===
                                                            _vm.form
                                                              .deliveryMethod
                                                              .id,
                                                        expression:
                                                          "(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "delivery__address_block",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.first_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_first_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .first_name,
                                                                      expression:
                                                                        "form.deliveryMethod.first_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressFirstName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_first_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .first_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "first_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.first_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.last_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_last_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .last_name,
                                                                      expression:
                                                                        "form.deliveryMethod.last_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressLastName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_last_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .last_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "last_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.last_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.middle_name"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_middle_name_ukraine"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c("sup", [
                                                                    _vm._v("*"),
                                                                  ]),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .middle_name,
                                                                      expression:
                                                                        "form.deliveryMethod.middle_name",
                                                                    },
                                                                  ],
                                                                  ref: "novaPoshtaAddressMiddleName",
                                                                  refInFor: true,
                                                                  staticClass:
                                                                    "form__control",
                                                                  attrs: {
                                                                    placeholder:
                                                                      _vm.get_translation_constant(
                                                                        "text_middle_name_ukraine"
                                                                      ),
                                                                    type: "text",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.form
                                                                        .deliveryMethod
                                                                        .middle_name,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .deliveryMethod,
                                                                          "middle_name",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.middle_name"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.text_your_city"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_your_city"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_enter_street_in_ukraine_letters"
                                                                        ),
                                                                      options:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .cities,
                                                                      label:
                                                                        "Description",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    on: {
                                                                      "search-change":
                                                                        _vm.asyncCities,
                                                                      select:
                                                                        _vm.loadStreetsOrWarehouses,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .city,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod
                                                                              .novaPoshta,
                                                                            "city",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.city",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.street"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "deliveryMethod.novaPoshta.warehouse"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_delivery_warehouse"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_enter_warehouse_in_ukraine_letters"
                                                                        ),
                                                                      options:
                                                                        _vm.warehouseList,
                                                                      label:
                                                                        "Description",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    on: {
                                                                      "search-change":
                                                                        _vm.searchTimeOutWarehouse,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .novaPoshta
                                                                          .warehouse,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod
                                                                              .novaPoshta,
                                                                            "warehouse",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.novaPoshta.warehouse",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "deliveryMethod.novaPoshta.warehouse"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "agent"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_recipient"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "multiselect",
                                                                  {
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      multiple: false,
                                                                      placeholder:
                                                                        _vm.get_translation_constant(
                                                                          "text_choose_agent"
                                                                        ),
                                                                      options:
                                                                        _vm.agentList,
                                                                      label:
                                                                        "name",
                                                                      selectLabel:
                                                                        "",
                                                                      deselectLabel:
                                                                        "",
                                                                      optionHeight: 48,
                                                                      showPointer: true,
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "singleLabel",
                                                                            fn: function (
                                                                              ref
                                                                            ) {
                                                                              var option =
                                                                                ref.option
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "multiselect__single",
                                                                                    class:
                                                                                      typeof option.id !==
                                                                                        "undefined" &&
                                                                                      option.id ===
                                                                                        ""
                                                                                        ? "multiselect__placeholder__active"
                                                                                        : "",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        typeof option.id !==
                                                                                          "undefined" &&
                                                                                          option.id ===
                                                                                            ""
                                                                                          ? _vm.get_translation_constant(
                                                                                              "text_delivery_through_agent"
                                                                                            )
                                                                                          : option.name
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm.form
                                                                          .deliveryMethod
                                                                          .agent,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .form
                                                                              .deliveryMethod,
                                                                            "agent",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "form.deliveryMethod.agent",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _vm.hasErrorMessage(
                                                                  "agent"
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form__error",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    " +
                                                                            _vm._s(
                                                                              _vm.get_translation_constant(
                                                                                "text_field_is_required"
                                                                              )
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 col-lg-6",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "form__col",
                                                                class:
                                                                  _vm.hasError(
                                                                    "phone_prefix"
                                                                  ) ||
                                                                  _vm.hasError(
                                                                    "phone_number"
                                                                  ),
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.get_translation_constant(
                                                                        "text_phone"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "phone__block",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "multiselect",
                                                                      {
                                                                        staticClass:
                                                                          "form-control",
                                                                        attrs: {
                                                                          multiple: false,
                                                                          placeholder:
                                                                            "",
                                                                          options:
                                                                            _vm.locationPrefixes,
                                                                          label:
                                                                            "title",
                                                                          selectLabel:
                                                                            "",
                                                                          deselectLabel:
                                                                            "",
                                                                          optionHeight: 48,
                                                                          showPointer: true,
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "singleLabel",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                              {
                                                                                key: "option",
                                                                                fn: function (
                                                                                  props
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "img",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__image",
                                                                                        attrs:
                                                                                          {
                                                                                            src: props
                                                                                              .option
                                                                                              .image,
                                                                                            width:
                                                                                              "16",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "option__title",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            props
                                                                                              .option
                                                                                              .title
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .form
                                                                              .phone_prefix,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_prefix",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "form.phone_prefix",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .phone_number,
                                                                              expression:
                                                                                "form.phone_number",
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "form__control type_tel",
                                                                        attrs: {
                                                                          type: "tel",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .phone_number,
                                                                          },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              if (
                                                                                $event
                                                                                  .target
                                                                                  .composing
                                                                              ) {
                                                                                return
                                                                              }
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "phone_number",
                                                                                $event
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm.hasErrorMessage(
                                                                      "phone_prefix"
                                                                    ) ||
                                                                    _vm.hasError(
                                                                      "phone_number"
                                                                    )
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form__error",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                        " +
                                                                                _vm._s(
                                                                                  _vm.get_translation_constant(
                                                                                    "text_field_is_required"
                                                                                  )
                                                                                ) +
                                                                                "\n                                                                    "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      : _vm.account.location_id === 2
                                      ? [
                                          method.shipping_type_id === 1
                                            ? void 0
                                            : method.shipping_type_id === 2
                                            ? void 0
                                            : _vm._e(),
                                        ]
                                      : _vm.account.location_id === 3
                                      ? [
                                          method.shipping_type_id === 1
                                            ? void 0
                                            : method.shipping_type_id === 2
                                            ? void 0
                                            : _vm._e(),
                                        ]
                                      : _vm.account.location_id === 4
                                      ? [
                                          method.shipping_type_id === 1
                                            ? void 0
                                            : method.shipping_type_id === 2
                                            ? void 0
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ]
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form__col form__col_collapse" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "collapsed",
                                      attrs: {
                                        "data-bs-toggle": "collapse",
                                        href: "#collapseComment",
                                        role: "button",
                                        "aria-expanded": "true",
                                        "aria-controls": "collapseComment",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.get_translation_constant(
                                              "text_comments"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "collapse show",
                                      attrs: { id: "collapseComment" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card card-body" },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.form.deliveryMethod
                                                    .comment,
                                                expression:
                                                  "form.deliveryMethod.comment",
                                              },
                                            ],
                                            staticClass: "form__control",
                                            attrs: {
                                              rows: "3",
                                              type: "text",
                                              placeholder:
                                                _vm.get_translation_constant(
                                                  "text_comment"
                                                ) + "...",
                                            },
                                            domProps: {
                                              value:
                                                _vm.form.deliveryMethod.comment,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.form.deliveryMethod,
                                                  "comment",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-md-flex justify-content-end mb-4",
                                },
                                [
                                  _c("input", {
                                    staticClass:
                                      "btn btn__large btn__green delivery__success d-block",
                                    attrs: {
                                      type: "submit",
                                      disabled: !_vm.deliveryValidated,
                                    },
                                    domProps: {
                                      value: _vm.get_translation_constant(
                                        "text_arrange_delivery"
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.submitDelivery.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("alert-modal", {
                attrs: {
                  title: _vm.modalTitle,
                  type: _vm.modalType,
                  message: _vm.modalMessage,
                  modalId: _vm.modalId,
                },
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.parcel.pictures.length
      ? _c(
          "div",
          { staticClass: "simple__block mt-4" },
          [
            _c("file-upload", {
              ref: "fileUpload",
              attrs: {
                files_array: _vm.serverPictures,
                multiple: true,
                translations: _vm.translations,
                ajax: false,
                lng: _vm.lng,
                upload_files_link: _vm.upload_files_link,
                delete_files_link: _vm.delete_files_link,
                additional_ajax_params: { parcel_id: _vm.parcel.id },
                downloadlink: _vm.downloadlink,
                template: "preview-photo",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }